package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.api.Mode
import com.nonopn.skydome.common.app.api.impl.ThunderDetectionEstimate
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.estimate.EstimateScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_admin_estimate
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavTypeWrapper
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterParameters
import kotlinx.serialization.Serializable
import kotlin.reflect.KType
import kotlin.reflect.typeOf

@Serializable
data class RouteEstimateExisting(
    val uuid: String,
    // val estimate: ThunderDetectionEstimate
) : RouteParameterTo

object RouterEstimateExisting : RouterParameters<RouteEstimateExisting>(RouteEstimateExisting::class) {
    override val typeMap: Map<KType, NavTypeWrapper<Any>>
        get() = mapOf(typeOf<ThunderDetectionEstimate>() to RouteEstimateExistingParametersType as NavTypeWrapper<Any>)

    override fun routeFrom(parameters: RouteEstimateExisting) =
        "/estimate/${parameters.uuid}"

    @Composable
    override fun Show(parameters: RouteEstimateExisting) {
        RouteEstimateExistingImpl(parameters).scene()
    }

    override fun navigateTo(instance: RouteEstimateExisting) = NavigateTo(
        route = instance,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteEstimateExisting

    override fun isMatching(route: String) = route.startsWith("/estimate/")

    override fun navigateFrom(path: String): RouteEstimateExisting {
        TODO()
    }
}

class RouteEstimateExistingImpl(params: RouteEstimateExisting) : Route<RouteEstimateExisting>(
    route = "/estimate/${params.uuid}",
    params = params,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val estimate = appModel.estimate(params.uuid)

        LaunchedEffect(Unit) {
            onEntryIsActive(appModel, emptyList())
        }

        EstimateScreen(
            modifier = Modifier.fillMaxSize(),
            appModel = appModel,
            mode = Mode.Normal,
            existingEstimate = estimate
        )
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_admin_estimate,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.Logout,
                    onClick = {
                        // appModel.show(NavigateTo.Main())
                    }
                )
            )
        )
    }
}

private val RouteEstimateExistingParametersType = NavTypeWrapper(
    serializer = ThunderDetectionEstimate.serializer(),
    deserialize = ThunderDetectionEstimate.serializer()
)
